export default {
  CPS: {
    id: 'CPS',
    mainChart: {
      name: '초당 세션 수',
      rscInfoList: [
        {
          rsctypeId: 'DEVICE_PERF',
          rscId: 'CPS',
        },
      ],
    },
  },
  CPU_USERATE: {
    id: 'CPU_USERATE',
    mainChart: {
      name: 'CPU 사용률',
      rscInfoList: [
        {
          rsctypeId: 'DEVICE_PERF',
          rscId: 'CPU_USERATE',
          isTotalCheck: true,
        },
      ],
    },
  },
  DEVICE_LOG: {
    id: 'DEVICE_LOG',
    mainChart: {
      name: '로그',
      rscInfoList: [
        {
          rsctypeId: 'SYSLOG',
          rscId: 'UNCHECKED_SYSLOG',
          rscKey: '_',
        },
        {
          rsctypeId: 'SNMPTRAP',
          rscId: 'UNCHECKED_SNMPTRAP',
          rscKey: '_',
        },
      ],
    },
  },
  DEVICE_RESPONSETIME: {
    id: 'DEVICE_RESPONSETIME',
    mainChart: {
      name: '응답시간',
      rscInfoList: [
        {
          rsctypeId: 'RESPONSETIME',
          rscId: 'RESPONSETIME_ICMP',
          rscKey: '_',
        },
        {
          rsctypeId: 'RESPONSETIME',
          rscId: 'RESPONSETIME_SNMP',
          rscKey: '_',
        },
      ],
    },
  },
  DEVICE_TEMP: {
    mainChart: {
      id: 'DEVICE_TEMP',
      name: '온도',
      rscInfoList: [
        {
          rsctypeId: 'DEVICE_PERF',
          rscId: 'DEVICE_TEMP',
          isTotalCheck: true,
        },
      ],
    },
  },
  DEVICE_TRAFFIC: {
    id: 'DEVICE_TRAFFIC',
    mainChart: {
      name: '장비 트래픽',
      rscInfoList: [
        {
          rsctypeId: 'DEVICE_TRAFFIC',
          rscId: 'TRAFFIC_BPS_IN',
          rscKey: '_',
        },
        {
          rsctypeId: 'DEVICE_TRAFFIC',
          rscId: 'TRAFFIC_BPS_OUT',
          rscKey: '_',
        },
      ],
    },
    subCharts: [
      {
        id: 'PPS',
        name: 'pps IN/OUT',
        rscInfoList: [
          {
            rsctypeId: 'DEVICE_TRAFFIC',
            rscId: 'TRAFFIC_PPS_IN',
            rscKey: '_',
          },
          {
            rsctypeId: 'DEVICE_TRAFFIC',
            rscId: 'TRAFFIC_PPS_OUT',
            rscKey: '_',
          },
        ],
      },
      {
        id: 'USERATE',
        name: '트래픽 이용률',
        rscInfoList: [
          {
            rsctypeId: 'DEVICE_TRAFFIC',
            rscId: 'TRAFFIC_USERATE_IN',
            rscKey: '_',
          },
          {
            rsctypeId: 'DEVICE_TRAFFIC',
            rscId: 'TRAFFIC_USERATE_OUT',
            rscKey: '_',
          },
        ],
      },
      {
        id: 'BROADCAST',
        name: 'Broadcast',
        rscInfoList: [
          {
            rsctypeId: 'DEVICE_TRAFFIC',
            rscId: 'TRAFFIC_PPSB_IN',
            rscKey: '_',
          },
          {
            rsctypeId: 'DEVICE_TRAFFIC',
            rscId: 'TRAFFIC_PPSB_OUT',
            rscKey: '_',
          },
        ],
      },
      {
        id: 'MULTICAST',
        name: 'Multicast',
        rscInfoList: [
          {
            rsctypeId: 'DEVICE_TRAFFIC',
            rscId: 'TRAFFIC_PPSM_IN',
            rscKey: '_',
          },
          {
            rsctypeId: 'DEVICE_TRAFFIC',
            rscId: 'TRAFFIC_PPSM_OUT',
            rscKey: '_',
          },
        ],
      },
    ],
  },
  DEVICE_TRAFFIC_ERROR: {
    id: 'DEVICE_TRAFFIC_ERROR',
    mainChart: {
      name: '장비 트래픽 에러\n(CRC, Collision)',
      rscInfoList: [
        {
          rsctypeId: 'DEVICE_TRAFFIC_ERROR',
          rscId: 'TRAFFIC_ERROR_IN',
          rscKey: '_',
        },
        {
          rsctypeId: 'DEVICE_TRAFFIC_ERROR',
          rscId: 'TRAFFIC_ERROR_OUT',
          rscKey: '_',
        },
        {
          rsctypeId: 'DEVICE_TRAFFIC_ERROR',
          rscId: 'TRAFFIC_DISCARD_IN',
          rscKey: '_',
        },
        {
          rsctypeId: 'DEVICE_TRAFFIC_ERROR',
          rscId: 'TRAFFIC_DISCARD_OUT',
          rscKey: '_',
        },
      ],
    },
    subCharts: [
      {
        id: 'CRC_COLLISION',
        name: 'CRC / Collision',
        rscInfoList: [
          {
            rsctypeId: 'DEVICE_TRAFFIC_ERROR',
            rscId: 'TRAFFIC_CRC_IN',
            rscKey: '_',
          },
          {
            rsctypeId: 'DEVICE_TRAFFIC_ERROR',
            rscId: 'TRAFFIC_COLLISION_OUT',
            rscKey: '_',
          },
        ],
      },
    ],
  },
  DEVICE_USERATE: {
    id: 'DEVICE_USERATE',
    mainChart: {
      name: 'CPU/MEM',
      rscInfoList: [
        {
          rsctypeId: 'DEVICE_PERF',
          rscId: 'CPU_USERATE',
          rscKey: '_',
        },
        {
          rsctypeId: 'DEVICE_PERF',
          rscId: 'MEM_USERATE',
          rscKey: '_',
        },
      ],
    },
  },
  MEM_USERATE: {
    id: 'MEM_USERATE',
    mainChart: {
      name: '메모리 사용률',
      rscInfoList: [
        {
          rsctypeId: 'DEVICE_PERF',
          rscId: 'MEM_USERATE',
          rscKey: '_',
        },
      ],
    },
  },
  MODULE_TEMP: {
    id: 'MODULE_TEMP',
    mainChart: {
      name: '모듈 온도',
      rscInfoList: [
        {
          rsctypeId: 'DEVICE_PERF',
          rscId: 'MODULE_TEMP',
          isTotalCheck: true,
        },
      ],
    },
  },
  PSLB: {
    id: 'PSLB',
    mainChart: {
      name: '물리 L4',
      rscInfoList: [
        {
          rsctypeId: 'RSLB',
          rscId: 'CURRENT_SESSIONS',
        },
      ],
    },
    subCharts: [
      {
        id: 'SESSION_PER_SECOND',
        name: '초당 세션수',
        rscInfoList: [
          {
            rsctypeId: 'RSLB',
            rscId: 'SESSION_PER_SECOND',
          },
        ],
      },
      {
        id: 'SESSIONS_USERATE',
        name: '세션',
        rscInfoList: [
          {
            rsctypeId: 'RSLB',
            rscId: 'SESSIONS_USERATE',
          },
        ],
      },
      {
        id: 'BYTES_IN',
        name: 'Bytes IN',
        rscInfoList: [
          {
            rsctypeId: 'RSLB',
            rscId: 'BYTES_IN',
          },
        ],
      },
      {
        id: 'BYTES_OUT',
        name: 'Bytes OUT',
        rscInfoList: [
          {
            rsctypeId: 'RSLB',
            rscId: 'BYTES_OUT',
          },
        ],
      },
      {
        id: 'PACKETS_IN',
        name: 'Packets IN',
        rscInfoList: [
          {
            rsctypeId: 'RSLB',
            rscId: 'PACKETS_IN',
          },
        ],
      },
      {
        id: 'PACKETS_OUT',
        name: 'Packets OUT',
        rscInfoList: [
          {
            rsctypeId: 'RSLB',
            rscId: 'PACKETS_OUT',
          },
        ],
      },
    ],
  },
  SESSION: {
    id: 'SESSION',
    mainChart: {
      name: '세션 수',
      rscInfoList: [
        {
          rsctypeId: 'DEVICE_PERF',
          rscId: 'SESSION',
        },
      ],
    },
  },
  THROUGHPUT: {
    id: 'THROUGHPUT',
    mainChart: {
      name: 'Throughput',
      rscInfoList: [
        {
          rsctypeId: 'DEVICE_PERF_L4',
          rscId: 'THROUGHOUT_PUT',
          rscKey: '_',
        },
      ],
    },
  },
  VSLB: {
    id: 'VSLB',
    mainChart: {
      name: '가상 L4',
      rscInfoList: [
        {
          rsctypeId: 'VSLB',
          rscId: 'CURRENT_SESSIONS',
        },
      ],
    },
    subCharts: [
      {
        id: 'SESSION_PER_SECOND',
        name: '초당 세션수',
        rscInfoList: [
          {
            rsctypeId: 'VSLB',
            rscId: 'SESSION_PER_SECOND',
          },
        ],
      },
      {
        id: 'SESSIONS_USERATE',
        name: '세션',
        rscInfoList: [
          {
            rsctypeId: 'VSLB',
            rscId: 'SESSIONS_USERATE',
          },
        ],
      },
      {
        id: 'BYTES_IN',
        name: 'Bytes IN',
        rscInfoList: [
          {
            rsctypeId: 'VSLB',
            rscId: 'BYTES_IN',
          },
        ],
      },
      {
        id: 'BYTES_OUT',
        name: 'Bytes OUT',
        rscInfoList: [
          {
            rsctypeId: 'VSLB',
            rscId: 'BYTES_OUT',
          },
        ],
      },
      {
        id: 'PACKETS_IN',
        name: 'Packets IN',
        rscInfoList: [
          {
            rsctypeId: 'VSLB',
            rscId: 'PACKETS_IN',
          },
        ],
      },
      {
        id: 'PACKETS_OUT',
        name: 'Packets OUT',
        rscInfoList: [
          {
            rsctypeId: 'VSLB',
            rscId: 'PACKETS_OUT',
          },
        ],
      },
    ],
  },
  POWER: {
    id: 'POWER',
    mainChart: {
      name: '사용 전력량',
      rscInfoList: [
        {
          rsctypeId: 'POE',
          rscId: 'POWER_CONSUMED',
        },
      ],
    },
    subCharts: [
      {
        id: 'POWER_ALLOCATED',
        name: '가용 전력량',
        rscInfoList: [
          {
            rsctypeId: 'POE',
            rscId: 'POWER_ALLOCATED',
          },
        ],
      },
    ],
  },
};



// WEBPACK FOOTER //
// ./src/views/performance/node/analysis/netdevice/perf-chart-type.js